import createBaseService from "@/api/base-service";
import type { Checklist } from "../../types/checklist";

const checklistService = {
	...createBaseService<Checklist>("/checklists"),

	/**
	 * Search checklists by name or description
	 */
	async search(query: string) {
		const response = await fetch(`/api/checklists?filter[search]=${encodeURIComponent(query)}`);
		return response.json();
	},

	/**
	 * Filter checklists by category
	 */
	async filterByCategory(category: string) {
		const response = await fetch(`/api/checklists?filter[category]=${encodeURIComponent(category)}`);
		return response.json();
	},

	/**
	 * Filter checklists by project
	 */
	async filterByProject(projectId: number) {
		const response = await fetch(`/api/checklists?filter[project_id]=${projectId}`);
		return response.json();
	},
};

export default checklistService;
